import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const AuthRedirect = () => {
  const { user, isAdmin, isOrgAdmin, userPortalAccess, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (user) {
    // First, check if the user needs to accept a pending agreement.
    const needsToAcceptAgreement = user.assignedAgreementId && !user.termsAcceptedAt;

    if (needsToAcceptAgreement) {
      localStorage.setItem('pendingAgreement', JSON.stringify({
        userId: user.id,
        agreementId: user.assignedAgreementId,
        email: user.email
      }));
      return <Navigate to="/user-agreement" replace />;
    }

    // SMART LOGIN ROUTING
    // 1. Super Admin → Admin Dashboard
    if (isAdmin) {
      return <Navigate to="/admin" replace state={location.state} />;
    }

    // 2. Firm Portal-only admin (isOrgAdmin but NO user portal access) → Firm Portal
    if (isOrgAdmin && !userPortalAccess) {
      return <Navigate to="/firm-portal" replace state={location.state} />;
    }

    // 3. Dual-access users (isOrgAdmin AND has user portal access) → Check preference
    if (isOrgAdmin && userPortalAccess) {
      const lastPortal = localStorage.getItem('lastPortalView');
      if (lastPortal === 'firm-portal') {
        return <Navigate to="/firm-portal" replace state={location.state} />;
      }
      return <Navigate to="/client-dashboard" replace state={location.state} />;
    }

    // 4. Regular users (no org admin access) → User Portal
    return <Navigate to="/client-dashboard" replace state={location.state} />;
  }

  // If no user is logged in, redirect to the login page.
  return <Navigate to="/login" replace />;
};

export default AuthRedirect;